import React from 'react';
import _ from 'underscore';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { titleize } from 'underscore.string';
import Badge from 'components/v2/Badge';
import { Card } from 'components/v2/stats';
const getCalendarLabel = (date) => (React.createElement("div", null,
    React.createElement("span", { className: "uppercase" }, `${moment(date)
        .format('ddd')
        .substring(0, 3)},`),
    React.createElement("span", { className: "uppercase px-1 " }, moment(date).format('MMM').substring(0, 3)),
    React.createElement("span", { className: "font-bold" }, moment(date).date())));
export default function AppointmentCalendarMetrics({ onCalendarClick, selectedDate, metrics, }) {
    const { t } = useTranslation();
    const TODAY = moment().startOf('day');
    let date = TODAY;
    const MAX_DAYS = 6;
    function isSelected(compare) {
        return (selectedDate &&
            moment(selectedDate).startOf('day').isSame(moment(compare).startOf('day')));
    }
    function getMetrics(date) {
        const items = metrics.filter((m) => {
            return moment(m.date).startOf('day').isSame(moment(date).startOf('day'));
        });
        return items.length ? _.first(items).data : {};
    }
    const yesterday = moment().subtract(1, 'days').startOf('day');
    const today = moment().startOf('day');
    const components = [
        React.createElement(AppointmentCalendarMetric, { key: "yesterday", label: t('YESTERDAY'), className: "flex-1 mb-2 sm:mb-0 flex ", date: yesterday, metrics: getMetrics(yesterday), onCalendarClick: onCalendarClick, selected: isSelected(yesterday) }),
        React.createElement(AppointmentCalendarMetric, { key: "today", label: t('TODAY'), className: "flex-1 mb-2 sm:mb-0 flex ", date: today, metrics: getMetrics(today), onCalendarClick: onCalendarClick, selected: isSelected(today) }),
    ];
    for (let i = 0; i < MAX_DAYS; i++) {
        date = moment(date).add(1, 'days');
        components.push(React.createElement(AppointmentCalendarMetric, { key: `date-${i}`, className: "flex-1 mb-2 sm:mb-0 flex ", date: date, label: getCalendarLabel(date), metrics: getMetrics(date), onCalendarClick: onCalendarClick, selected: isSelected(date) }));
    }
    return components;
}
function AppointmentCalendarMetric({ label, date, metrics, selected, onCalendarClick, }) {
    const start = moment(date).startOf('day').toISOString();
    const end = moment(date).endOf('day').toISOString();
    const { t } = useTranslation();
    const cardClassNames = classnames({
        'mt-2': true,
        'cursor-pointer': true,
        border: true,
        'border-green': selected,
        'border-solid': true,
        'hover:border': true,
        'hover:border-8': true,
        'hover:border-green': true,
        'hover:border-solid': true,
    });
    if (_.isEmpty(metrics)) {
        return (React.createElement(Card, { className: cardClassNames, label: label, onClick: () => onCalendarClick({ start, end }) },
            React.createElement("div", null, t('NO_APPTS'))));
    }
    function onCalendarStatusClick(e, data) {
        e.stopPropagation();
        onCalendarClick(data);
    }
    return (React.createElement(Card, { label: label, className: cardClassNames, onClick: () => onCalendarClick({ start, end }) },
        React.createElement("div", { className: "mt-2 space-y-1" },
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('APPROVED'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'approved', start, end }) },
                    React.createElement(Badge, { color: "green" }, metrics.approved))),
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('PENDING'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'pending', start, end }) },
                    React.createElement(Badge, { color: "blue" }, metrics.pending))),
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('DECLINED'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'declined', start, end }) },
                    React.createElement(Badge, { color: "red" }, metrics.declined))),
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('MISSED'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'missed', start, end }) },
                    React.createElement(Badge, { color: "yellow" }, metrics.missed))),
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('COMPLETE'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'complete', start, end }) },
                    React.createElement(Badge, { color: "purple" }, metrics.complete))),
            React.createElement("div", { className: "flex space-x-2 justify-between" },
                React.createElement("span", null, titleize(t('CANCELED'))),
                React.createElement("div", { onClick: (e) => onCalendarStatusClick(e, { status: 'canceled', start, end }) },
                    React.createElement(Badge, { color: "gray" }, metrics.canceled))))));
}
